import React from 'react';
import PropTypes from 'prop-types';
import DrawerBase from './DrawerBase';

class Drawer extends React.Component {
  getStyles = type => {
    switch (type) {
      case 'questionnaire':
        return {
          drawerPaper: {
            maxWidth: '600px',
            width: '100%',
            overflowY: 'initial',
            top: '0px',
            position: 'absolute',
          },
        };
      case 'engagementTeam':
        return {
          drawerPaper: {
            width: '800px',
            overflowY: 'initial',
            top: '0px',
            position: 'absolute',
          },
        };
      case 'secondary':
        // modify mobile / tablet / compose view top value
        return {
          drawerPaper: {
            top: this.props.isMobile ? (this.props.topFixed ? '0px' : '75px') : '126px',
            overflowX: 'hidden',
            overflowY: 'hidden',
            flex: 'none',
          },
          fullList: {
            width: 'auto',
          },
        };
      default:
        return {};
    }
  };
  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <DrawerBase styles={styles} {...otherProps} />;
  }
}

Drawer.propTypes = {
  open: PropTypes.bool,
  anchor: PropTypes.string,
  variant: PropTypes.string,
  onClose: PropTypes.func,
};

Drawer.defaultProps = {
  styleType: 'default',
};

export default Drawer;
